<div class="col-lg-6 d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100 w-100">
    <div class="w-100 p-4 p-md-5 card border-0" style="max-width: 40rem; background-color: #e4eeff;">
        <!-- Form -->
        <form class="row g-1 p-0 p-md-4">
            <div class="col-12 text-center mb-5">
                <img src="../../assets/images/auth-two-step.svg" class="w240 mb-4" alt="" />
                <h1>Actualizar credenciales</h1>
                <span>Ingrese la clave SII de su empresa para validarla.</span>
            </div>
            
            <div class="input-group mb-3 mr-5">
                <div class="input-group-prepend">
                  <span class="input-group-text form-control form-control-lg text-center"> <strong>CLAVE SII:</strong>
                </span>
                </div>
                <input [(ngModel)]="sii" type="text" class="form-control" name="sii">
            </div>
            <div *ngIf="!isUpdating && selectedOrganization && userInfo" class="col-12 text-center mt-4">
                <a (click)="onEnviar()" title="" class="btn btn-lg btn-primary lift text-uppercase">Validar</a>
            </div>
            <app-loader-w-message *ngIf="isUpdating"></app-loader-w-message>
        </form>
        <!-- End Form -->
    </div>
</div>
<!-- <div class="row mt-5">
    <button (click)="onEnviar()" type="button" class="btn btn-primary send-button">Enviar</button>
</div> -->